import CodeEditor from './CodeEditor.vue';

export default [
  CodeEditor,
];
